

// Routes
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './components/home/Home';
import Question1 from './components/question1/Question1';
import Question2 from './components/question2/Question2';
import Question3 from './components/question3/Question3';
import Complaint from './components/complaint/Complaint';
import Navbar from './components/navbar/Navbar';
import GoogleReview from './components/googleReview/GoogleReview';
import Config from './components/config/Config';
import Polling from './components/polling/Polling';
import PollingOutcome from './components/polling/PollingOutcome';


function App() {
 
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/question1" element={<Question1 />} />
        <Route path="/question2" element={<Question2 />} />
        <Route path="/question3" element={<Question3 />} />
        <Route path="/complaint" element={<Complaint />} />
        <Route path="/config" element={<Config />} />
        <Route path="/googleReview" element={<GoogleReview />} />
        <Route path="/polling" element={<Polling />} />
        <Route path="/polling-outcome/:pollId/:rewardCode/:votedOptionId?" element={<PollingOutcome />} />
        <Route path="/device-access" element={<Home />} />
      </Routes>
    </Router>
    
  );
}

export default App;
